// extracted by mini-css-extract-plugin
export default {"FullPageLoader":"FullPageLoader__FullPageLoader___wW4rW","loader":"FullPageLoader__loader___rDlCv","threeDots":"FullPageLoader__threeDots___p9EVS"};